import { type ReactNode } from 'react';
import { makeStyles } from '@mui/styles';
import {type Theme, Grid, Typography, GridProps} from '@mui/material';
import {useMobileScreen} from 'hooks';

const useStyles = makeStyles((theme : Theme) => ({
  titleContainer: {
    paddingBottom: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  title: {
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4.5, 0, 4.5),
    },
    [theme.breakpoints.down('sm')]: {
      padding: 0,
    },
  },
  actions: {
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 0, 4),
    },
  }
}), {name: 'AdminPageHeader'});

export type AdminPageHeaderProps = {
  title: ReactNode;
  actions?: ReactNode;
};

const AdminPageHeader = ({ title, actions } : AdminPageHeaderProps) : JSX.Element => {
  const classes = useStyles();
  const isMobileScreenWidth = useMobileScreen();
  const gridProps : Partial<GridProps> = isMobileScreenWidth
  ? {
      spacing: 4,
      wrap: 'wrap'
    }
  : {
      spacing: 1,
      wrap: 'nowrap'
    }
  const gridItemProps : Partial<GridProps> = isMobileScreenWidth
  ? {xxs: 12}
  : {}
  return (
    <Grid className={classes.titleContainer} container justifyContent='space-between' alignItems='center' {...gridProps}>
      <Grid item {...gridItemProps}>
        <Typography className={classes.title} variant='h2'>{title}</Typography>
      </Grid>
      {actions && (
        <Grid className={classes.actions} item {...gridItemProps}>
          {actions}
        </Grid>
      )}
    </Grid>
  );
};

export default AdminPageHeader;